import {
  DEFAULT_SCANNER_EXCHANGE,
  DEFAULT_SCANNER_TIMEFRAME,
  DEFAULT_SCANNER_UNIVERSE,
} from './scannerExperienceShared';

const SCANNER_ANONYMOUS_LIMIT_HEADER = 'X-Scanner-Anonymous-Limit-Applied';

function normalizeBoolean(value) {
  return value ? 'true' : 'false';
}

function ensureOk(response, fallbackMessage) {
  if (response.ok) {
    return response;
  }
  throw new Error(fallbackMessage);
}

export async function fetchScannerOverview(filters = {}, options = {}) {
  const query = new URLSearchParams({
    universe: filters.universe || DEFAULT_SCANNER_UNIVERSE,
    exchange: filters.exchange || DEFAULT_SCANNER_EXCHANGE,
    timeframe: filters.timeframe || DEFAULT_SCANNER_TIMEFRAME,
    bullishOnly: normalizeBoolean(filters.direction === 'BULLISH'),
    bearishOnly: normalizeBoolean(filters.direction === 'BEARISH'),
    topMoversOnly: normalizeBoolean(filters.topMoversOnly),
    forceRefresh: normalizeBoolean(options.forceRefresh),
  });

  const response = ensureOk(
    await fetch(`/api/scanner?${query.toString()}`),
    'Scanner indisponible',
  );
  const rows = await response.json();
  const anonymousLimitHeader = response.headers.get(SCANNER_ANONYMOUS_LIMIT_HEADER);
  return {
    rows: Array.isArray(rows) ? rows : [],
    anonymousLimitApplied: anonymousLimitHeader === null ? null : anonymousLimitHeader === 'true',
  };
}

export async function fetchScannerDetail(symbol, options = {}) {
  const query = new URLSearchParams({
    exchange: options.exchange || DEFAULT_SCANNER_EXCHANGE,
    timeframe: options.timeframe || DEFAULT_SCANNER_TIMEFRAME,
    candles: String(options.candles || 450),
    imageCandles: String(options.imageCandles || 120),
    historyLimit: String(options.historyLimit || 10),
  });

  const response = ensureOk(
    await fetch(`/api/scanner/${encodeURIComponent(symbol)}?${query.toString()}`),
    'Analyse indisponible',
  );
  return response.json();
}

export async function fetchTradePlan(symbol, options = {}) {
  const query = new URLSearchParams({
    exchange: options.exchange || DEFAULT_SCANNER_EXCHANGE,
    timeframe: options.timeframe || DEFAULT_SCANNER_TIMEFRAME,
    candles: String(options.candles || 450),
    imageCandles: String(options.imageCandles || 120),
  });

  const response = ensureOk(
    await fetch(`/api/scanner/${encodeURIComponent(symbol)}/trade-plan?${query.toString()}`),
    'Trade plan indisponible',
  );
  return response.json();
}

export function buildPatternImageRequestUrl(analysis, options = {}) {
  const query = new URLSearchParams();
  const { forceSymbolLookup = false } = options;
  if (!forceSymbolLookup && analysis?.imagePath) {
    query.set('imagePath', analysis.imagePath);
  }
  if (analysis?.symbol) {
    query.set('symbol', analysis.symbol);
  }
  if (analysis?.exchange) {
    query.set('exchange', analysis.exchange);
  }
  if (analysis?.timeframe) {
    query.set('timeframe', analysis.timeframe);
  }
  if (analysis?.imageVersion) {
    query.set('version', analysis.imageVersion);
  }
  if (analysis?.imageGeneratedAt) {
    query.set('generatedAt', analysis.imageGeneratedAt);
  }
  if (analysis?.analysisTimestamp) {
    query.set('analysisTimestamp', analysis.analysisTimestamp);
  }
  return `/api/pattern/image?${query.toString()}`;
}

export async function fetchPatternImageAsBlob(analysis, options = {}) {
  const { signal, forceSymbolLookup = false } = options;
  const response = await fetch(buildPatternImageRequestUrl(analysis, { forceSymbolLookup }), signal ? { signal } : undefined);
  if (!response.ok) {
    return null;
  }
  return response.blob();
}
